import { useConfig, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { useEffect, useMemo, useState } from 'react';
import PaymentService from '../services/payment-service/payment-service';
import { PaymentProcessorType } from '../types/payment/payment-processor-type';

export const useShowPaymentEnrollment = (locationId?: number): boolean | undefined => {
  const { config } = useConfig();
  const { oidcService } = useOidcWithAdmin();
  const paymentService = useMemo(() => new PaymentService(config, oidcService), [config, oidcService]);
  const [paymentProcessorType, setPaymentProcessorType] = useState<PaymentProcessorType>();

  useEffect(() => {
    if (!locationId) return;

    let cancelled = false;
    setPaymentProcessorType(undefined);

    paymentService
      .getPaymentProcessorType(locationId)
      .then((type) => {
        if (!cancelled) setPaymentProcessorType(type);
      })
      .catch((error) => {
        console.error('Failed to load payment processor type: ', error);
      });

    return () => {
      cancelled = true;
    };
  }, [locationId, paymentService]);

  if (paymentProcessorType === undefined) return undefined;

  return paymentProcessorType === 'None' || paymentProcessorType === 'Legacy';
};
